export enum GallaryType {
  photo = 1,
  album = 2,
  yearbook = 3
}
